/** Traducciones de interfaz (ES / EN / FR / DE / IT / PT). Los textos largos de servicios viven en serviciosCopy.js. */

import { siteCopy } from './siteCopy'

export const messages = {
  es: {
    nav: {
      openMenu: 'Abrir menú de navegación',
      trayectoria: 'Trayectoria',
      productos: 'Productos',
      productosSinfonicos: 'Productos Sinfónicos',
      disponibilidadInmediata: 'disponibilidad inmediata',
      musicaPeliculas: 'Música de Películas / Musicales',
      servicios: 'Servicios',
      testimonios: 'Testimonios',
      contacto: 'Contacto',
    },
    hero: {
      role: 'Director de Orquesta, Compositor y Orquestador',
      disciplines: 'Arreglos - Orquestaciones - Transcripciones - Composiciones',
      quote: '«Llevando tu música a la partitura\ny al escenario».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Director de Orquesta, Compositor y Orquestador',
      cta: 'Contáctame',
    },
    footer: {
      contactUs: 'Contáctame',
      mailSubject: 'Contacto — Eduardo Gajardo Schmidlin',
      rights: 'Derechos reservados © {year} PWebDev',
      scrollUp: 'Volver a la barra de navegación',
    },
    carousel: {
      swipe: 'Deslizar',
      moreServices: 'ver más servicios',
    },
    video: {
      region: 'Reproductor de video',
      label: 'Video próximamente',
    },
    testimonials: {
      soon: 'Contenido próximamente.',
    },
    services: {
      composiciones: 'Composiciones',
      orquestaciones: 'Orquestaciones',
      arreglosCorales: 'Arreglos Corales',
      transcripcionPartituras: 'Transcripción de partituras',
      otrosArreglos: 'Otros arreglos',
    },
  },
  en: {
    nav: {
      openMenu: 'Open navigation menu',
      trayectoria: 'Career',
      productos: 'Catalogue',
      productosSinfonicos: 'Symphonic Catalogue',
      disponibilidadInmediata: 'available now',
      musicaPeliculas: 'Cinema in Concert / Musicals',
      servicios: 'Services',
      testimonios: 'Testimonials',
      contacto: 'Contact',
    },
    hero: {
      role: 'Conductor, Composer and Orchestrator',
      disciplines: 'Arrangements — Orchestrations — Transcriptions — Compositions',
      quote: '«Your music, on the score\nand on the stage».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Conductor, Composer and Orchestrator',
      cta: 'Contact me',
    },
    footer: {
      contactUs: 'Contact me',
      mailSubject: 'Enquiry — Eduardo Gajardo Schmidlin',
      rights: 'All rights reserved © {year} PWebDev',
      scrollUp: 'Back to the navigation bar',
    },
    carousel: {
      swipe: 'Swipe',
      moreServices: 'see more services',
    },
    video: {
      region: 'Video player',
      label: 'Video coming soon',
    },
    testimonials: {
      soon: 'Coming soon.',
    },
    services: {
      composiciones: 'Compositions',
      orquestaciones: 'Orchestrations',
      arreglosCorales: 'Choral Arrangements',
      transcripcionPartituras: 'Score Transcription',
      otrosArreglos: 'Other arrangements',
    },
  },
  fr: {
    nav: {
      openMenu: 'Ouvrir le menu de navigation',
      trayectoria: 'Parcours',
      productos: 'Catalogue',
      productosSinfonicos: 'Catalogue symphonique',
      disponibilidadInmediata: 'disponibles dès maintenant',
      musicaPeliculas: 'Musiques de Films en Concert / Comédies musicales',
      servicios: 'Services',
      testimonios: 'Témoignages',
      contacto: 'Contact',
    },
    hero: {
      role: 'Chef d’orchestre, Compositeur et Orchestrateur',
      disciplines: 'Arrangement — Orchestration — Transcription — Composition',
      quote: '«Votre musique, sur la partition\net sur la scène».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Chef d’orchestre, Compositeur et Orchestrateur',
      cta: 'Contactez-moi',
    },
    footer: {
      contactUs: 'Contactez-moi',
      mailSubject: 'Contact — Eduardo Gajardo Schmidlin',
      rights: 'Tous droits réservés © {year} PWebDev',
      scrollUp: 'Retour à la barre de navigation',
    },
    carousel: {
      swipe: 'Glisser',
      moreServices: 'voir plus de services',
    },
    video: {
      region: 'Lecteur vidéo',
      label: 'Vidéo à venir',
    },
    testimonials: {
      soon: 'À venir.',
    },
    services: {
      composiciones: 'Composition',
      orquestaciones: 'Orchestration',
      arreglosCorales: 'Arrangements choraux',
      transcripcionPartituras: 'Transcription de partitions',
      otrosArreglos: 'Autres arrangements',
    },
  },
  de: {
    nav: {
      openMenu: 'Navigationsmenü öffnen',
      trayectoria: 'Werdegang',
      productos: 'Katalog',
      productosSinfonicos: 'Sinfonischer Katalog',
      disponibilidadInmediata: 'sofort verfügbar',
      musicaPeliculas: 'Filmmusik im Konzert / Musicals',
      servicios: 'Leistungen',
      testimonios: 'Stimmen',
      contacto: 'Kontakt',
    },
    hero: {
      role: 'Dirigent, Komponist und Orchestrator',
      disciplines: 'Arrangements — Orchestration — Transkriptionen — Komposition',
      quote: '«Ihre Musik, in der Partitur\nund auf der Bühne».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Dirigent, Komponist und Orchestrator',
      cta: 'Kontaktieren Sie mich',
    },
    footer: {
      contactUs: 'Kontaktieren Sie mich',
      mailSubject: 'Kontakt — Eduardo Gajardo Schmidlin',
      rights: 'Alle Rechte vorbehalten © {year} PWebDev',
      scrollUp: 'Zurück zur Navigationsleiste',
    },
    carousel: {
      swipe: 'Wischen',
      moreServices: 'weitere Leistungen',
    },
    video: {
      region: 'Videoplayer',
      label: 'Video in Kürze',
    },
    testimonials: {
      soon: 'Folgt in Kürze.',
    },
    services: {
      composiciones: 'Kompositionen',
      orquestaciones: 'Orchestrationen',
      arreglosCorales: 'Chorarrangements',
      transcripcionPartituras: 'Partiturtranskription',
      otrosArreglos: 'Weitere Arrangements',
    },
  },
  it: {
    nav: {
      openMenu: 'Apri il menu di navigazione',
      trayectoria: 'Percorso',
      productos: 'Catalogo',
      productosSinfonicos: 'Catalogo sinfonico',
      disponibilidadInmediata: 'subito disponibili',
      musicaPeliculas: 'Musiche da film in concerto / Musical',
      servicios: 'Servizi',
      testimonios: 'Testimonianze',
      contacto: 'Contatto',
    },
    hero: {
      role: 'Direttore d’orchestra, Compositore e Orchestratore',
      disciplines: 'Arrangiamenti — Orchestrazioni — Trascrizioni — Composizioni',
      quote: '«La tua musica, in partitura\ne sul palcoscenico».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Direttore d’orchestra, Compositore e Orchestratore',
      cta: 'Contattami',
    },
    footer: {
      contactUs: 'Contattami',
      mailSubject: 'Contatto — Eduardo Gajardo Schmidlin',
      rights: 'Tutti i diritti riservati © {year} PWebDev',
      scrollUp: 'Torna alla barra di navigazione',
    },
    carousel: {
      swipe: 'Scorri',
      moreServices: 'vedi altri servizi',
    },
    video: {
      region: 'Lettore video',
      label: 'Video in arrivo',
    },
    testimonials: {
      soon: 'In arrivo.',
    },
    services: {
      composiciones: 'Composizioni',
      orquestaciones: 'Orchestrazioni',
      arreglosCorales: 'Arrangiamenti corali',
      transcripcionPartituras: 'Trascrizione di partiture',
      otrosArreglos: 'Altri arrangiamenti',
    },
  },
  pt: {
    nav: {
      openMenu: 'Abrir menu de navegação',
      trayectoria: 'Trajetória',
      productos: 'Catálogo',
      productosSinfonicos: 'Catálogo Sinfônico',
      disponibilidadInmediata: 'disponíveis de imediato',
      musicaPeliculas: 'Música de Filmes em Concerto / Musicais',
      servicios: 'Serviços',
      testimonios: 'Depoimentos',
      contacto: 'Contato',
    },
    hero: {
      role: 'Maestro, Compositor e Orquestrador',
      disciplines: 'Arranjos — Orquestrações — Transcrições — Composições',
      quote: '«A sua música, na partitura\ne no palco».',
      photoAlt: 'Eduardo Gajardo Schmidlin, Maestro, Compositor e Orquestrador',
      cta: 'Fale comigo',
    },
    footer: {
      contactUs: 'Fale comigo',
      mailSubject: 'Contato — Eduardo Gajardo Schmidlin',
      rights: 'Todos os direitos reservados © {year} PWebDev',
      scrollUp: 'Voltar à barra de navegação',
    },
    carousel: {
      swipe: 'Deslize',
      moreServices: 'ver mais serviços',
    },
    video: {
      region: 'Reprodutor de vídeo',
      label: 'Vídeo em breve',
    },
    testimonials: {
      soon: 'Em breve.',
    },
    services: {
      composiciones: 'Composições',
      orquestaciones: 'Orquestrações',
      arreglosCorales: 'Arranjos corais',
      transcripcionPartituras: 'Transcrição de partituras',
      otrosArreglos: 'Outros arranjos',
    },
  },
}

for (const code of Object.keys(siteCopy)) {
  if (messages[code]) Object.assign(messages[code], siteCopy[code])
}

export function translate(locale, path, vars) {
  const lang = messages[locale] ? locale : 'es'
  const parts = String(path).split('.')
  let cur = messages[lang]
  for (const part of parts) {
    if (cur == null || typeof cur !== 'object') return path
    cur = cur[part]
  }
  if (typeof cur !== 'string') return path
  if (!vars) return cur
  return cur.replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] != null ? String(vars[key]) : `{${key}}`,
  )
}
